import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {MailOrdersListFiltersProvider} from './core/MailOrdersListFiltersProvider'
import {MailOrdersTable} from './table/MailOrdersTable'
import {KTCard} from '../../../../_dashboard/helpers'
import {MailOrdersListHeader} from './header/MailOrdersListHeader'

const MailOrdersList = () => {
  return (
    <KTCard>
      <MailOrdersListHeader />
      <MailOrdersTable />
    </KTCard>
  )
}

const MailOrdersListWrapper = () => (
  <QueryRequestProvider>
    <MailOrdersListFiltersProvider>
      <QueryResponseProvider>
        <MailOrdersList />
      </QueryResponseProvider>
    </MailOrdersListFiltersProvider>
  </QueryRequestProvider>
)

export {MailOrdersListWrapper}
